import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
  TATARSTAN_ID,
} from '../constants/geoSwitcher';
import { IApplicationState } from '../types/redux';
import { selectSubdomainRegionId } from './selectSubdomainRegionId';

export function selectIsCountryBuildingsBannersAvailable(state: IApplicationState) {
  const subdomainRegionId = selectSubdomainRegionId(state);

  return [
    MOSCOW_REGION_ID,
    MOSCOW_AREA_REGION_ID,
    MOSCOW_WITH_AREA_REGION_ID,
    ST_PETERSBURG_REGION_ID,
    ST_PETERSBURG_AREA_REGION_ID,
    ST_PETERSBURG_WITH_AREA_REGION_ID,
    TATARSTAN_ID,
  ].includes(subdomainRegionId);
}
